import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Spinner, Alert } from "react-bootstrap";
import instance from "../../../services/baseService";
import toast from "react-hot-toast";
import { useParams } from 'react-router-dom';

const CreateScripModal = ({ show, onHide, portCode, sbNoList = [] }) => {
    const [formData, setFormData] = useState({
        scrip_no: "",
        scroll_no: "",
        scrip_date: "",
        port_code: portCode || "",
    });

    const [submitting, setSubmitting] = useState(false);
    const [validated, setValidated] = useState(false);
    const [error, setError] = useState(null);
    const { client_id, report_id } = useParams();
    useEffect(() => {
        if (show && portCode) {
            setFormData(prev => ({
                ...prev,
                port_code: portCode
            }));
        }
    }, [show, portCode]);

    useEffect(() => {
        setFormData({
            scrip_no: "",
            scroll_no: "",
            scrip_date: "",
            port_code: portCode || "",
        });
    }, [portCode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        setSubmitting(true);
        setError(null);

        try {
            // Dummy API call simulation
            const payload = {
                scrip_no: formData.scrip_no,
                scroll_no: formData.scroll_no,
                scrip_date: formData.scrip_date,
                port_code: formData.port_code,
                sbNoList: sbNoList,
            };

            // Simulate API delay
            await new Promise((resolve) => setTimeout(resolve, 1000));

            // Replace this with your actual endpoint
            const response = await instance.post(
                `/api/v1/reconciliation/manual/scrip/${client_id}/${report_id}`,
                payload
            );

            if (response.data?.type === "success") {
                toast.success(response.data.message || "Scrip created successfully!");
                onHide();
            } else {
                setError(response.data?.message || "Failed to create scrip.");
            }
        } catch (err) {
            console.log(err);
            const message =
                err?.response?.data?.message ||
                err?.message ||
                "Something went wrong while creating the scrip.";
            setError(message);
        } finally {
            setSubmitting(false);
        }
    };


    const handleClose = () => {
        setValidated(false);
        setError(null);
        setFormData({
            scrip_no: "",
            scrip_date: "",
            scroll_no: "",
            port_code: portCode || "",
        });
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            centered
            backdropClassName="white-backdrop-top"
            className="top-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Create Scrip</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && (
                    <Alert
                        variant="danger"
                        dismissible
                        onClose={() => setError(null)}
                        className="mb-3"
                    >
                        {error}
                    </Alert>
                )}

                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>
                            Scrip No <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            name="scrip_no"
                            value={formData.scrip_no}
                            onChange={handleChange}
                            required
                            placeholder="Enter Scrip Number"
                        />
                        <Form.Control.Feedback type="invalid">
                            Scrip number is required.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Scroll No <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            name="scroll_no"
                            value={formData.scroll_no}
                            onChange={handleChange}
                            required
                            placeholder="Enter Scroll Number"
                        />
                        <Form.Control.Feedback type="invalid">
                            Scroll number is required.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Scrip Date <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="date"
                            name="scrip_date"
                            value={formData.scrip_date}
                            onChange={handleChange}
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Scrip date is required.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>
                            Port Code <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            name="port_code"
                            value={formData.port_code}
                            onChange={handleChange}
                            required
                            disabled
                            placeholder="Enter Port Code"
                        />
                        <Form.Control.Feedback type="invalid">
                            Port code is required.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={submitting}
                        >
                            {submitting ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Creating...
                                </>
                            ) : (
                                "Create"
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateScripModal;
